<template>
  <div class="prize_user_row">
    <div class="user_img_bg">
      <AvatarImage
        :src="winner.userDTO?.avatar || winner.avatar"
        :alt="winnerUsername"
        image-class="not_clickable"
        @error="handleImageError"
      />
    </div>

    <div class="col_mobile">
      <div class="user_info">
        <p class="name not_clickable">{{ winnerUsername }}</p>
        <p class="cash">{{ winnerPrizeDescription }}</p>
      </div>

      <div class="date_box">
        <p class="date_txt">{{ $_translations.value.page_winners_public_user_item_date }}</p>
        <p class="date">{{ formatShortDate(winnerDate) }}</p>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import AvatarImage from '@/components/image/AvatarImage.vue';

const props = defineProps({
  winner: {
    type: Object,
    required: true,
    default: () => ({}),
  },
});

// Computed properties for winner data
const winnerUsername = computed(() => {
  return props.winner.username ||
    props.winner.userDTO?.username ||
    'Anonymous';
});

const winnerPrizeDescription = computed(() => {
  return props.winner.prizeDTO?.headline ||
    props.winner.rewardDescription ||
    'Prize';
});

const winnerDate = computed(() => {
  return props.winner.winDate ||
    props.winner.rewardDate ||
    props.winner.localDateTime ||
    '';
});

// Format date for display (short format DD/MM/YYYY)
const formatShortDate = (dateString) => {
  if (!dateString) return 'DD/MM/YYYY';

  try {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  } catch {
    return 'DD/MM/YYYY';
  }
};

// Handle avatar image errors
const handleImageError = (event) => {
  event.target.src = '/static/images/avatars/avatar_01.svg';
};
</script>
